import { useMutation, useLazyQuery } from '@apollo/client';
import React, {
  useCallback,
  useContext,
  useState,
  useEffect,
  useRef
} from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import {
  Spotlight,
  TextContainer,
  ResourceItem,
  ResourceList,
  Modal,
  TextStyle
} from '@superops/ui-design-system';
import {
  NoDataCard,
  ClientSideDropDown,
  SkeletonTableLoading,
  isAuthorised,
  AppContext,
  getTranslatedText,
  noRestrictionToPlans,
  useCheckFeatureGating,
  useProduct
} from '@nile/components';
import {
  GET_SEARCH_DATA,
  GET_RECENT_SEARCH_DATA,
  UPDATE_RECENT_SEARCH_DATA
} from '@nile/banyan/src/Graphql/Mutations/search';
import SearchBox from '@nile/mangifera/src/Components/Search/SearchBox';

import { AccountClient } from '@nile/graphql';
import { withRouter } from 'react-router-dom';
import envConfig from '@nile/home/src/Config/env';
import EditUserContainerNew from '@nile/client_management/src/Containers/Requester/EditUserContainerNew';
import { SVGIcon } from '@superops/super-icons';

import { debounce, isEmpty } from 'lodash';
import WorkItemListPopup from './WorkItemListPopup';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';
import { GET_KB_SEARCH } from '@nile/rmm/src/modules/knowledge-base/graphql/query';
import { MLClient } from '@nile/graphql';
import { useFlags } from 'launchdarkly-react-client-sdk';

const KNOWLEDGE_BASE_MODULE = 'KB_ARTICLE';

function SpotlightPage(props) {
  const { intl, setSpotlightOverlay, noSpotLight } = props;
  const [active, setActive] = useState(true);
  const flags = useFlags();
  const [selected, setSelected] = useState(0);
  const [selectedText, setSelectedText] = useState('');
  const [searchResult, setSearchResult] = useState();
  const [selectedSite, setSelectedSite] = useState('');
  const [selectedClient, setSelectedClient] = useState('');
  const [selectedSiteId, setSelectedSiteId] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState([]);
  const [recentSearchdResult, setRecentSearchdResult] = useState();
  const [sheetActive, setSheetActive] = useState(false);
  const [getRequester, setRequester] = useState('');
  const isITProduct = useCheckIsItProduct();
  const handleChange = useCallback(
    () => setActive(!active),
    setSpotlightOverlay(active),
    [active]
  );
  const isMSPProduct = useProduct('MSP');
  const tabContext = props.tabRef;
  const appContext = useContext(AppContext);
  const reference = appContext.user?.role?.roleFeatureList || [];

  const chargeBeePlanId = appContext.user?.chargeBeePlanId.toLowerCase();

  const tabsArgs = [
    {
      id: '1',
      content: 'Tickets',
      moduleName: 'TICKET',
      authorisation: ['tickets'],
      placeholder: getTranslatedText(intl, 'app.common.search.in', {
        name: getTranslatedText(intl, 'app.modules.workspace.ticket')
      }),
      FeatureNameInBackend: 'TICKETING'
    },
    {
      id: '2',
      content: 'Assets',
      moduleName: 'ASSET',
      authorisation: ['asset'],
      placeholder: getTranslatedText(intl, 'app.common.search.in', {
        name: getTranslatedText(intl, 'ticket.details.insights.assets')
      }),
      FeatureNameInBackend: 'WINDOWS_MANAGEMENT'
    },
    {
      id: '3',
      content: 'Clients',
      moduleName: 'CLIENT',
      authorisation: ['client'],
      placeholder: getTranslatedText(intl, 'app.common.search.in', {
        name: getTranslatedText(intl, 'client.mainpage.header')
      }),
      FeatureNameInBackend: 'CLIENT_MANAGEMENT',
      productToCheck: 'MSP'
    },
    {
      id: '4',
      content: 'Requester',
      moduleName: 'USER',
      authorisation: ['users'],
      placeholder: getTranslatedText(intl, 'app.common.search.in', {
        name: getTranslatedText(intl, 'ticket.details.header.req')
      }),
      FeatureNameInBackend: 'CLIENT_MANAGEMENT'
    },
    {
      id: '5',
      content: 'Project',
      moduleName: 'PROJECT',
      authorisation: ['project'],
      placeholder: getTranslatedText(intl, 'app.common.search.in', {
        name: getTranslatedText(intl, 'app.modules.workspace.project')
      }),
      FeatureNameInBackend: 'PROJECT_MANAGEMENT'
    },
    {
      id: '6',
      content: 'Task',
      moduleName: 'TASK',
      authorisation: ['ticket', 'project'],
      placeholder: getTranslatedText(intl, 'app.common.search.in', {
        name: getTranslatedText(intl, 'app.modules.workspace.task')
      }),
      FeatureNameInBackend: 'PROJECT_MANAGEMENT'
    },
    {
      id: '7',
      content: 'Knowledge Base',
      moduleName: 'KB_ARTICLE',
      authorisation: ['knowledgeBase'],
      placeholder: getTranslatedText(intl, 'app.common.search.in', {
        name: getTranslatedText(intl, 'common.knowledge.base')
      }),
      FeatureNameInBackend: 'KNOWLEDGE_BASE'
    }
  ];
  /* Filter by allowed feature */
  const allowedTabList = tabsArgs.filter((obj) => {
    if (obj.productToCheck && !(obj.productToCheck === 'MSP' && isMSPProduct)) {
      return false;
    }
    /* No restriction to the plan like NFR */
    return noRestrictionToPlans.includes(chargeBeePlanId)
      ? obj
      : useCheckFeatureGating(obj?.FeatureNameInBackend)?.enabled;
  });
  /* authorisation for allowed feature */
  const authorisedTab = allowedTabList.filter((obj) => {
    if (obj?.ldFlag && !flags[obj.ldFlag]) {
      return false;
    }
    if (obj.authorisation) {
      const isFeatureAuthorised = obj.authorisation.reduce(
        (acc, role) => isAuthorised(reference, `${role}.view`) || acc,
        false
      );
      return isFeatureAuthorised;
    }
    return obj;
  });
  const [selectedModule, setSelectedModule] = useState(
    authorisedTab[selected]?.moduleName
  );
  const selectedModuleRef = useRef(selectedModule);

  useEffect(() => {
    selectedModuleRef.current = selectedModule;
  }, [selectedModule]);

  const [selectedObj, setSelectedObj] = useState(authorisedTab[selected]);

  function getSearchVariables(module, searchText) {
    const variablesData = {
      term: searchText,
      modules: [module],
      filters: {
        sites: selectedSiteId
      },
      pageInfo: {
        pageSize: 30
      }
    };
    if (isMSPProduct) {
      variablesData.filters.clients = selectedClientId;
    }
    return variablesData;
  }

  const [
    onSearchAPI,
    { loading: searchLoading, error: searchError }
  ] = useLazyQuery(GET_SEARCH_DATA, {
    client: AccountClient,
    fetchPolicy: 'cache-and-network',
    variables: getSearchVariables(selectedModule, selectedText),
    onCompleted({ search }) {
      setSearchResult(search?.documents);
    },
    onError({ search }) {
      setSearchResult(search?.documents);
    }
  });

  const [
    onGetArticles,
    { loading: articlesLoading, error: articlesError }
  ] = useLazyQuery(GET_KB_SEARCH, {
    client: MLClient,
    fetchPolicy: 'cache-and-network',
    onCompleted(res) {
      if (res?.knowledgeBaseSearch) {
        setSearchResult(res?.knowledgeBaseSearch);
      }
    },
    onError(res) {
      setSearchResult(res?.knowledgeBaseSearch);
    }
  });

  const getArticles = (searchText) => {
    onGetArticles({ variables: { searchTerm: searchText } });
  };

  const checkNumber = (text) => {
    return /^\d+$/.test(text);
  };
  const handleTabChange = useCallback((selectedTabIndex) => {
    setSelected(selectedTabIndex);
    const newModule = authorisedTab[selectedTabIndex]?.moduleName;
    setSelectedModule(newModule);
    setSelectedObj(authorisedTab[selectedTabIndex]);

    const shouldSearch = selectedText?.length > 2 || checkNumber(selectedText);
    if (!shouldSearch) {
      setSearchResult([]);
      return;
    }

    const searchAction =
      newModule === KNOWLEDGE_BASE_MODULE
        ? () => getArticles(selectedText)
        : () =>
            onSearchAPI({
              variables: { ...getSearchVariables(newModule, selectedText) }
            });

    searchAction();
  });

  const [showFilter, setShowFilter] = useState(
    selectedModule !== KNOWLEDGE_BASE_MODULE
  );

  useEffect(() => {
    setShowFilter(selectedModule !== KNOWLEDGE_BASE_MODULE);
  }, [selectedModule]);

  const onSearch = (searchText) => {
    const currentModule = selectedModuleRef.current;
    if (searchText.length > 2 || checkNumber(searchText)) {
      setSelectedText(searchText);
      if (currentModule !== KNOWLEDGE_BASE_MODULE) {
        onSearchAPI();
      } else {
        getArticles(searchText);
      }
    }
    if (searchText.length === 0) {
      setSelectedText(' ');
    }
  };
  const inputChange = useCallback(debounce(onSearch, 600), []);
  const handleClientSiteChange = (val, type) => {
    if (type === 'client.name') {
      setSelectedClient(val);
      setSelectedClientId(!val ? [] : [val?.accountId]);
    } else {
      setSelectedSite(val);
      setSelectedSiteId(!val ? [] : [val?.id]);
    }
  };

  useEffect(() => {
    onSearch(selectedText);
  }, [selectedSite, selectedClient]);

  const [
    updateRecentSearch,
    { loadingUpdateRecentSearch, errorUpdateRecentSearch }
  ] = useMutation(UPDATE_RECENT_SEARCH_DATA, {
    client: AccountClient,
    onError() {}
  });

  const [
    recentSearch,
    { loadingRecentSearch, errorRecentSearch }
  ] = useLazyQuery(GET_RECENT_SEARCH_DATA, {
    client: AccountClient,
    fetchPolicy: 'cache-and-network',
    onCompleted({ getRecentSearchInfo }) {
      setRecentSearchdResult(getRecentSearchInfo);
    },
    onError() {}
  });

  useEffect(() => {
    recentSearch();
  }, []);

  const openTabObject = (menulist) => {
    tabContext.current.openTabCb({
      ...menulist
    });
  };
  const globalTabContext = (menu) => {
    switch (menu?.module) {
      case 'TICKET':
        openTabObject({
          module: 'TICKET',
          data: {
            ticketId: menu?.ticketId
          }
        });
        setSheetActive(false);
        break;
      case 'ASSET_DETAILS':
        openTabObject({
          module: 'ASSET_DETAILS',
          data: {
            id: menu?.data.id,
            classId: menu?.data?.classId,
            subject: menu?.data?.subject
          }
        });
        setSheetActive(false);
        break;
      default:
        break;
    }
  };
  const setVariable = (menulist) => {
    // recentSearch();
    updateRecentSearch({
      variables: {
        term: selectedText,
        hit: {
          entityId: menulist?.entityId,
          entityType: menulist?.entityType,
          parentEntityType: menulist?.parentEntityType,
          parentEntityId: menulist?.parentEntityId
        }
      }
    });
  };

  const handleCreation = (menulist) => {
    setVariable(menulist);
    switch (menulist?.entityType || menulist?.userType) {
      case 'Ticket':
        if (menulist.displayData.client !== null) {
          openTabObject({
            module: 'TICKET',
            data: {
              ticketId: menulist?.entityId
            }
          });
        }
        break;
      case 'TicketConversation':
      case 'ChatConversation':
      case 'TicketNote':
        openTabObject({
          module: 'TICKET',
          data: {
            ticketId: menulist?.parentEntityId
          }
        });
        break;
      case 'Asset':
        openTabObject({
          module: 'ASSET_DETAILS',
          data: {
            id: menulist?.entityId,
            classId: menulist?.displayData?.classId,
            subject: menulist?.displayData?.name.replace(/(<([^>]+)>)/gi, '')
          }
        });
        break;
      case 'Client':
        openTabObject({
          module: 'CLIENT',
          data: {
            id: menulist?.entityId,
            name: menulist?.displayData?.name.replace(/(<([^>]+)>)/gi, ''),
            value: menulist?.displayData?.name.replace(/(<([^>]+)>)/gi, '')
          }
        });
        break;
      case 'Site':
        openTabObject({
          module: 'CLIENT',
          data: {
            id: menulist?.parentEntityId,
            name: menulist?.displayData?.client?.name.replace(
              /(<([^>]+)>)/gi,
              ''
            ),
            value: menulist?.displayData?.client?.name.replace(
              /(<([^>]+)>)/gi,
              ''
            )
          }
        });
        break;
      case 'Project':
        openTabObject({
          module: 'PROJECT_DETAIL',
          data: {
            projectId: menulist?.entityId,
            title: menulist?.displayData?.name.replace(/(<([^>]+)>)/gi, '')
          }
        });
        break;
      case 'TECHNICIAN':
      case 'REQUESTER':
        openTabObject({
          module: 'KB_ARTICLE',
          data: {
            id: menulist?.id,
            type: 'read'
          }
        });
        break;
      case 'ProjectConversation':
        openTabObject({
          module: 'PROJECT_DETAIL',
          data: {
            projectId: menulist?.parentEntityId,
            title: menulist?.parentEntityId?.displayData?.name.replace(
              /(<([^>]+)>)/gi,
              ''
            )
          }
        });
        break;

      case 'Task':
        if (menulist?.parentEntityType === 'Ticket') {
          openTabObject({
            module: 'TICKET',
            data: {
              ticketId: menulist?.parentEntityId
            }
          });
        } else if (menulist?.parentEntityType === 'Project') {
          openTabObject({
            module: 'PROJECT_DETAIL',
            data: {
              projectId: menulist?.parentEntityId,
              title: menulist?.displayData?.name.replace(/(<([^>]+)>)/gi, '')
            }
          });
        }
        break;
      case 'User':
        setRequester(menulist?.entityId);
        setSheetActive(true);
        break;
      default:
        break;
    }
  };

  const ContainerComp = noSpotLight ? WorkItemListPopup : Spotlight;

  const SearchResultComponent = (
    <div
      className={`left-sec search-result-wrap ${
        showFilter ? '' : 'full-width'
      }`}
    >
      <div className="full-height full-width overflow-auto">
        {searchResult?.length > 0 ? (
          <ResourceList
            items={searchResult}
            renderItem={(menulist, index) => {
              return searchLoading || articlesLoading ? (
                <SkeletonTableLoading
                  tableHeader={false}
                  tableRow={2}
                  tableColumn={1}
                  theme
                />
              ) : (
                <div>
                  <ResourceItem
                    id={menulist?.entityId}
                    key={menulist?.entityId}
                    onClick={handleCreation.bind(this, menulist)}
                    gutter="xs"
                    theme="dark"
                  >
                    <SearchBox
                      menulist={menulist}
                      selectedModule={selectedModule}
                      tabContext={tabContext}
                    />
                  </ResourceItem>
                </div>
              );
            }}
          />
        ) : (
          <>
            {searchLoading || articlesLoading ? (
              <SkeletonTableLoading
                tableHeader={false}
                tableRow={2}
                tableColumn={1}
                theme
              />
            ) : (
              <>
                {selectedText?.length > 2 || checkNumber(selectedText) ? (
                  <div className="flex actr jctr fhp">
                    <NoDataCard
                      darkTheme
                      height="130px"
                      width="180px"
                      imageURL={`url(${`${envConfig.imageRoot}svg/search-new.svg`})`}
                      description={getTranslatedText(
                        intl,
                        'common.no.search.found'
                      )}
                    />
                  </div>
                ) : (
                  <>
                    {recentSearchdResult?.recentHits?.length > 0 ? (
                      <>
                        <p className="pl-15 pb-5">
                          <TextStyle variation="subdued" uppercase>
                            <FormattedMessage id="common.search.results" />
                          </TextStyle>
                        </p>
                        <ResourceList
                          items={recentSearchdResult?.recentHits}
                          renderItem={(recentSearchMenulist, index) => {
                            return (
                              <div>
                                <ResourceItem
                                  id={recentSearchMenulist?.entityId}
                                  key={recentSearchMenulist?.entityId}
                                  onClick={handleCreation.bind(
                                    this,
                                    recentSearchMenulist
                                  )}
                                  gutter="xs"
                                  theme="dark"
                                >
                                  <SearchBox
                                    menulist={recentSearchMenulist}
                                    tabContext={tabContext}
                                  />
                                </ResourceItem>
                              </div>
                            );
                          }}
                        />
                      </>
                    ) : (
                      <div className="flex actr jctr fhp">
                        <NoDataCard
                          darkTheme
                          height="130px"
                          width="180px"
                          imageURL={`url(${`${envConfig.imageRoot}svg/search-new.svg`})`}
                          description={getTranslatedText(
                            intl,
                            'common.start.search'
                          )}
                        />
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );

  if (noSpotLight) {
    return <>{SearchResultComponent}</>;
  }

  return (
    <>
      <ContainerComp
        open={active}
        onClose={handleChange}
        title="search"
        large
        variant="search"
        selected={selected}
        onSelect={handleTabChange}
        onChangeSearch={inputChange}
        tabs={authorisedTab}
        placeholder={selectedObj?.placeholder}
      >
        <TextContainer>
          <div className="full-height flex col">
            <div className="flex border-top-gray">
              {SearchResultComponent}
              {showFilter && (
                <div className="right-sec filter-sec search-result-wrap">
                  <ClientSideDropDown
                    selectedSite={selectedSite}
                    selectedClient={selectedClient}
                    onChange={handleClientSiteChange}
                    flexColumn
                    theme
                  />
                </div>
              )}
            </div>
          </div>
        </TextContainer>
      </ContainerComp>

      <Modal
        open={sheetActive}
        onClose={() => setSheetActive(false)}
        showCloseButton
        fullScreen
      >
        <EditUserContainerNew
          id={getRequester}
          type="edit"
          newLayout
          mixpanelSource="Search requester popup"
          globalTabContext={globalTabContext}
          actions={{
            closeRequesterModal: () => setSheetActive(false)
          }}
        />
      </Modal>
    </>
  );
}
export default injectIntl(withRouter(SpotlightPage));
